import { BlockerCard } from './BlockerCard';
import type { BlockerSummary } from '../../features/blockers/types';

export interface BlockerBoardProps {
  blockers: BlockerSummary[];
  goalTitles: Map<string, string>;
  workstreamTitles: Map<string, string>;
  storyTitles: Map<string, string>;
  onOpenGoal: (goalId: string) => void;
  onOpenWorkstream: (workstreamId: string) => void;
  onResolve: (blocker: BlockerSummary) => void;
  onReopen: (blocker: BlockerSummary) => void;
  onDelete: (blocker: BlockerSummary) => void;
}

/**
 * The Blockers board — a priority-ordered stack of blocker cards (open first,
 * longest-blocking first). Ordering is decided upstream by the hook
 * (sortBlockers); this component only renders + wires each card's actions.
 */
export function BlockerBoard({
  blockers,
  goalTitles,
  workstreamTitles,
  storyTitles,
  onOpenGoal,
  onOpenWorkstream,
  onResolve,
  onReopen,
  onDelete,
}: BlockerBoardProps) {
  return (
    <div className="space-y-4">
      {blockers.map((b) => (
        <BlockerCard
          key={b.id}
          blocker={b}
          goalTitle={b.affectedGoalId ? goalTitles.get(b.affectedGoalId) : undefined}
          workstreamTitle={
            b.blockedWorkstreamId ? workstreamTitles.get(b.blockedWorkstreamId) : undefined
          }
          storyTitle={b.blockedStoryId ? storyTitles.get(b.blockedStoryId) : undefined}
          onOpenGoal={onOpenGoal}
          onOpenWorkstream={onOpenWorkstream}
          onResolve={onResolve}
          onReopen={onReopen}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
}

export default BlockerBoard;
